/*
 * @Author: Suroc
 * @Date: 2024-07-11 14:15:56
 * @LastEditTime: 2025-01-11 22:54:47
 * @Description: 
 */
const ko = {
  // 头部导航
  Header: {
    SuperMarket: "CCR LAND",
    Connect: "지갑 연결",
  },
  // 底部导航
  Footer: {
    Home: "홈",
    Mining: "농장",
    Profit: "거래",
    Flst: "NFT",
    Team: "마이페이지",
  },
  // 首页
  Home: {
    Account: "계정",
    Share: "공유",
    Reference: "추천인",
    BindWallet: "지갑을 먼저 바인딩하세요",
    Ecological: "마이닝 머신",
    Pledge: "스테이킹",
    Conduct: "자산 관리",
    ToLoan: "대출",
    Metaverse: "메타버스",
    ChainGame: "블록체인 게임",
    ShoppingMall: "몰",
    SwapBut: "탐색",
  },
  // 矿机
  Mint: {
    OnSale: "판매 중",
    StopSelling: "판매 중단",
    F1MiningMachine: "F1 마이닝 머신",
    F2MiningMachine: "F2 마이닝 머신",
    F3MiningMachine: "F3 마이닝 머신",
    F4MiningMachine: "F4 마이닝 머신",
    F5MiningMachine: "F5 마이닝 머신",
    Authorize: "승인",
    BuyNow: "즉시 구매",
    PurchaseFLST: "FLST 구매",
  },
  // 收益
  Profit: {
    Hold: "보유 머신 가치",
    UnStatic: "미수령 정적 수익",
    UnDynamics: "미수령 동적 수익",
    StaticTotal: "정적 총수익 (수령 완료)",
    DynamicTotal: "동적 총수익 (수령 완료)",
    MyIncome: "총수익",
    Receive: "수령",
    MyRecord: "수익 기록",
    Money: "금액 (U)",
    Quantity: "토큰 수량",
    Time: "시간",
  },
  // 团队
  Team: {
    SuperiorAddress: "상위 주소",
    Performance: "내 실적",
    TeamSize: "팀 인원 수",
    Referral: "내 직추천 인원",
    Direct: "내 팀",
    Address: "주소",
    Money: "금액 (U)",
    Time: "시간",
    CopyLink: "링크 복사",
  },
  // 公共消息弹窗
  Prompt: {
    Admin: "접근 권한 없음",
    AdminInfo: "예외 발생",
    AdminModified: "수정 성공",
    AdminModification: "수정 실패",
    PurchaseSucceeded: "구매 성공",
    PurchaseFailed: "구매 실패",
    BindingSucceeded: "바인딩 성공",
    BindingFailed: "바인딩 실패",
    ConnectWallet: "지갑을 먼저 연결하세요",
    Confirm: "확인",
    Cancel: "취소",
    GoGetIt: "수령하러 가기",
    SoldOut: "매진",
    NotYetDev: "아직 오픈되지 않음",
    NewIssueSuccess: "수령 성공",
    NewIssueError: "수령 실패",
    TransactionErr: "거래 실패",
    BalanceErr: "잔액 부족",
    USDTBalanceErr: "USDT 잔액 부족",
    FLSTBalanceErr: "FLST 잔액 부족",
    AllowanceErr: "승인 부족",
    AllowanceSuccess: "승인 성공",
    InviteInfo1: "당신은",
    InviteInfo2: "의 초대를 통해 방문했습니다. 관계를 바인딩하시겠습니까?",
    ProfitInfo: "미수령 수익이 있습니다. 수령 후 구매하세요",
    ProfitInfo2: "미수령 수익이 없습니다",
    Fail: "오류",
  },
  nongC: {
    Home: "홈",
    Farm: "농장",
    Trade: "거래",
    NFT: "NFT",
    Mine: "마이페이지",
    Share: "공유",
    Referrer: "추천인",
    Lv: "현재 레벨",
    Bal: "잔액",
    CHZSoil: "흑칼슘토",
    KSTSoil: "밤칼슘토",
    SRZSoil: "갈칼슘토",
    GRZSoil: "회칼슘토",
    Plant: "심기",
    Harvest: "수확",
    Buy: "구매",
    TaxRt: "세율",
    Prc: "가격",
    Qty: "수량",
    Mkt: "마켓",
    Mint: "민팅",
    BBox: "블라인드 박스",
    BuyBBox: "블라인드 박스 구매",
    SellOrder: "매도 주문",
    SellMarket: "판매 등록",
    Cancel: "취소",
    Claim: "수령",
    ContriDiv: "기여 배당 대리 수령",
    EquityDiv: "권익 배당 대리 수령",
    EquityVal: "권익 가치",
    ContriVal: "기여 가치",
    DivList: "배당 목록",
    MyTeam: "내 팀",
    MyDown: "하위 라인",
    MyUpss: "상위 라인",
    TeamMaxLv: "팀 최고 레벨",
    DirectRefPerf: "직접 추천 실적",
    Bind: "바인딩",
    Sale: "판매",
    HistoryPrice: "역사 가격",
    Error: "오류",
  },
  common: {
    crzfh: "C 인증 배당",
    contri: "기여 배당",
    contriAmount: "배당 금액",
    myArea: "내 영역",
    myBind: "내 바인딩",
    noBind: "바인딩 없음",
    ktAdress: "개척 주소",
    crz: "C 인증",
    qyz: "권익 가치",
    none: "없음",
    payAmount: "지불 수량",
    sale: "판매",
    amount: "수량",
    investment: "투자",
    released: "해제 완료",
    cycle: "주기",
    plantTime: "심기 시간",
    lastHarvest: "마지막 수확",
    harvest: "수확",
    hgt: "흑칼슘토",
    lgt: "밤칼슘토",
    zgt: "갈칼슘토",
    huigt: "회칼슘토",
    plantNow: "즉시 심기",
    makeSure: "확인",
    czzqsh: "처리 중입니다. 잠시 기다려주세요...",
    ljqdts: "누적 체크인 일수:",
    dh: "교환",
    wqd: "체크인 안 함",
    dqd: "체크인 대기",
    kfzqdd: "개발 중입니다. 잠시 기다려주세요",
    gqbzwjrqx: "이 지갑은 접근 권한이 없습니다",
    zwkf: "아직 오픈되지 않음",
    sqcg: "승인 성공",
    sqsb: "승인 실패",
    zzcg: "민팅 성공",
    zzsb: "민팅 실패",
    dkcg: "열기 성공",
    dksb: "열기 실패",
    cg: "성공",
    sb: "실패",
    open: "열기",
    buy: "구매",
    free: "무료",
    zzhqsj: "데이터를 가져오는 중입니다",
    zwtjr: "추천인 없음",
    destroy: "파괴",
    sywcc: "미생산 잔량",
    dhfm: "10일 23시간 15분 15초",
    xcrq: "다음 날짜",
    zwzsdnft: "판매 중인 NFT 없음",
    mc: "이름:",
    fortyfiveDay: "45일",
    token: "토큰",
    price: "가격", 
    total: "총액",
    uybind: "바인딩하시겠습니까",
    zgyqmm: "이 초대 코드를?",
    zwyqm: "초대 코드 없음",
    wcxdyqm: "초대 코드를 찾을 수 없습니다",
    bindSuccess: "바인딩 완료",
    zwkf: "아직 오픈되지 않음",
    lq: "수령",
    fail: "실패",
    mygdl: "더 이상 없습니다",
    jine: "금액:",
    shijian: "시간:",
    tq: "출금",
    tqd: "출금 완료",
    dsf: "해제 대기",
    zzsf: "해제 중",
    sfwc: "해제 완료",
    jz: "가치:",
    zz: "심기",
    zq: "주기",
    Hour: "시간",
    Day: "일",
    Min: "분",
    Sec: "초",
    limit: "남은 사용 가능",
    tq: "훔치기",
  },
};

export default ko;